module.exports = __webpack_public_path__ + "img/pdf.9e94f667.png";